// extracted by css-extract-rspack-plugin
export default {"container":"container-3cDyZ","illustration":"illustration-2a8MU","header":"header-3z2xg"};